module.exports = __webpack_public_path__ + "img/thumb.b28dfa66.jpg";